import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { showError } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
// Basic Components
import TextInputCashDrawerCount from 'screens/components/basic/TextInputCashDrawerCount';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import Button from 'screens/components/basic/Button';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';


const pageName = 'POSCashDrawerCount';

class POSCashDrawerCount extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: false,
            dialogConfirm: false
        };
    }

    clearInputs = () => {
        this.props.clearFormInput(`${pageName}100Count`);
        this.props.clearFormInput(`${pageName}50Count`);
        this.props.clearFormInput(`${pageName}20Count`);
        this.props.clearFormInput(`${pageName}10Count`);
        this.props.clearFormInput(`${pageName}5Count`);
        this.props.clearFormInput(`${pageName}2Count`);
        this.props.clearFormInput(`${pageName}1Count`);
        this.props.clearFormInput(`${pageName}25CentsCount`);
        this.props.clearFormInput(`${pageName}10CentsCount`);
        this.props.clearFormInput(`${pageName}5CentsCount`);
        this.props.clearFormInput(`${pageName}1CentCount`);
    }

    confirmCountCash = (source) => {
        let formName = "";
        if (source == "cashDrop") {
            formName = "POSCashDropCashDropAmount";
        } else if (source == "cashIn") {
            formName = "POSCashInCashInAmount";
        } else if (source == "cashOut") {
            formName = "POSCashOutCashOutAmount";
        }
        this.props.formInput(this.props.totalAmountValue, formName);
        this.props.onConfirm();
    }

    render() {
        const { t } = this.props; 
        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.cashDrawerCount.countDrawerCash')} handleClose={() => this.props.onCancel()} />}
                    modal={true}
                    open={this.props.show}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '99999' }}
                    actions={[]}
                    contentStyle={{ width: '65%' }}>
                    <div className="row">
                        <div className="col-lg-6">
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}100Count`}
                                min={0}
                                moneyLabel={"$ 100"}
                                moneyValue={100}
                            />
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}50Count`}
                                min={0}
                                moneyLabel={"$ 50"}
                                moneyValue={50}
                            />
                            <TextInputCashDrawerCount
                                className="col-lg-12"
                                type="number"
                                name={`${pageName}20Count`}
                                min={0}
                                moneyLabel={"$ 20"}
                                moneyValue={20}
                            />
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}10Count`}
                                min={0}
                                moneyLabel={"$ 10"}
                                moneyValue={10}
                            />
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}5Count`}
                                min={0}
                                moneyLabel={"$ 5"}
                                moneyValue={5}
                            />
                        </div>
                        <div className="col-lg-6">
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}2Count`}
                                min={0}
                                moneyLabel={"$ 2"}
                                moneyValue={2}
                            />
                            <TextInputCashDrawerCount
                                className="col-lg-12"
                                type="number"
                                name={`${pageName}1Count`}
                                min={0}
                                moneyLabel={"$ 1"}
                                moneyValue={1}
                            />
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}25CentsCount`}
                                min={0}
                                moneyLabel={"25c"}
                                moneyValue={0.25}
                            />
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}10CentsCount`}
                                min={0}
                                moneyLabel={"10c"}
                                moneyValue={0.1}
                            />
                            <TextInputCashDrawerCount
                                type="number"
                                name={`${pageName}5CentsCount`}
                                min={0}
                                moneyLabel={"5c"}
                                moneyValue={0.05}
                            />
                        </div>
                    </div>
                    <div className="row align-items-center mt-1">
                        <div className="col-lg-6 field-center">
                            <h3 className="m-0">
                                {t('pos.cashDrawerCount.totalValue')}: ${this.props.totalAmountValue}
                            </h3>
                        </div>
                        <div className="col-lg-6 text-right">
                            <Button
                                key={2}
                                name="buttonConfirmCashIn"
                                label={t('common.confirm')}
                                primary={true}
                                onTouchTap={() => this.confirmCountCash(this.props.source)} />
                        </div>
                    </div>
                </DialogInput>
                {/* Confirmation Dialog */}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        totalAmountValue: (Number(state.form[`${pageName}100Count`] || 0) * 100 + Number(state.form[`${pageName}50Count`] || 0) * 50 + Number(state.form[`${pageName}20Count`] || 0) * 20
            + Number(state.form[`${pageName}10Count`] || 0) * 10 + Number(state.form[`${pageName}5Count`] || 0) * 5 + Number(state.form[`${pageName}2Count`] || 0) * 2
            + Number(state.form[`${pageName}1Count`] || 0) * 1 + Number(state.form[`${pageName}25CentsCount`] || 0) * 0.25 + Number(state.form[`${pageName}10CentsCount`] || 0) * 0.1
            + Number(state.form[`${pageName}5CentsCount`] || 0) * 0.05 + Number(state.form[`${pageName}1CentCount`] || 0) * 0.01).toFixed(2)
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSCashDrawerCount))